export enum CssRuleType {
    Normal,
    MediaStart,
    MediaEnd,
}
